export const WEEKLY_RECURRING = "WEEKLY";
export const MONTHLY_RECURRING = "MONTHLY";
export const QUARTERLY_RECURRING = "QUARTERLY";
export const YEARLY_RECURRING = "YEARLY";

export const WEEKLY_RECURRING_LABEL = "Weekly";
export const MONTHLY_RECURRING_LABEL = "Monthly";
export const QUARTERLY_RECURRING_LABEL = "Quarterly";
export const YEARLY_RECURRING_LABEL = "Yearly";
